export { ContactInfoView } from './ContactInfoView.ui';
